import { NoticeModal } from '@lili/lili-frontend-common';
import { ReactComponent as OopsIcon } from '@/assets/svg/icons/oops.svg';

// Hardcoded strings — this component renders when the app tree has crashed,
// so i18n providers may not be available.
const TITLE = 'Oops, something went wrong';
const DESCRIPTION = 'Please try again later. If the problem persists, contact support.';
const BUTTON = 'OK';

export const ErrorFallback = () => {
  const handleReload = () => {
    window.location.reload();
  };

  return (
    <NoticeModal
      id='error-fallback-modal'
      image={<OopsIcon />}
      title={TITLE}
      content={DESCRIPTION}
      buttonText={BUTTON}
      onSubmit={handleReload}
      onClickOutside={handleReload}
    />
  );
};
